// extracted by mini-css-extract-plugin
module.exports = {"container":"NavFilter_container__1XkM0","counters":"NavFilter_counters__X31ZF","panel":"NavFilter_panel__24ICO","description":"NavFilter_description__17fM4"};